<template>
  <transition name="slide">
    <div v-if="comment || nag" class="move-comment">
      <template v-if="nag">
        <div class="is-flex is-align-items-center">
          <b-tag type="is-info">{{ nag }}</b-tag>
          <span class="has-text-grey ml-2">{{ nagDescription }}</span>
        </div>
      </template>
      <span v-if="comment" class="comment-text">{{ comment }}</span>
    </div>
  </transition>
</template>

<script>
import { NAG_MAP } from "vue-chess-shared/pgn/Nag";

export default {
  name: "MoveComment",

  props: {
    comment: {
      type: String,
      default: null,
    },
    nag: {
      type: String,
      default: null,
    },
  },

  computed: {
    nagDescription() {
      return this.nag ? NAG_MAP[this.nag] || "" : "";
    },
  },
};
</script>

<style scoped>
.move-comment {
  background-color: #f6f9fe;
  border-radius: 4px;
  padding: 0.75rem;
  white-space: pre-wrap;
  line-height: 1.4;
}

.comment-text {
  color: #363636;
}

/* Transition animations */
.slide-enter-active,
.slide-leave-active {
  transition: all 0.3s ease;
  max-height: 200px;
}

.slide-enter-from,
.slide-leave-to {
  opacity: 0;
  max-height: 0;
  transform: translateY(-10px);
}
</style>
